import './FileUploadZone.css';

export default function FileUploadZone({ file, onFileSelect }) {
  const handleDrop = (event) => {
    event.preventDefault();
    const dropped = event.dataTransfer.files[0];
    if (dropped) {
      onFileSelect(dropped);
    }
  };

  return (
    <div
      className="upload-zone"
      onDragOver={(event) => event.preventDefault()}
      onDrop={handleDrop}
    >
      <div className="upload-icon">☁️</div>
      <p>Glissez et déposez votre fichier (PDF, DOC ou DOCX) ici, ou</p>
      <label className="upload-button">
        Sélectionner un fichier
        <input
          type="file"
          accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          onChange={(event) => onFileSelect(event.target.files[0])}
          hidden
        />
      </label>
      <span className="upload-hint">
        {file ? file.name : 'Aucun fichier sélectionné'}
      </span>
    </div>
  );
}
